import { Text } from "@simplybusiness/mobius";

import type { LabelValue } from "./types";

export const HeaderItemRow = ({ label, value }: LabelValue) => (
  <>
    <Text variant="small" spacing="tight">
      <strong className="mobius-payment-items-section__header-label">
        {label}
      </strong>
    </Text>
    <Text
      variant="small"
      spacing="tight"
      className="mobius-payment-items-section__value"
    >
      <strong className="mobius-payment-items-section__header-label">
        {value}
      </strong>
    </Text>
  </>
);

HeaderItemRow.displayName = "HeaderItemRow";
